import { call, put, takeLatest, fork } from 'redux-saga/effects'
import { AuroraAction } from '../reducers'
import {
  REQUEST_PREDICTED_K_INDEX,
  RECEIVE_PREDICTED_K_INDEX,
  ERROR_PREDICTED_K_INDEX,
} from '../actions/kIndex'
import { getData } from '../utils/api'
import { CHANGE_MAGNETOMETER, CHANGE_PERIOD } from '../actions'
import { updateUrl } from '../utils/utils'

function* fetchPredictedKIndex(action: AuroraAction) {
  try {
    const data = yield call(getData, action.url)
    yield put({ type: RECEIVE_PREDICTED_K_INDEX, data: data })
  } catch (e) {
    yield put({ type: ERROR_PREDICTED_K_INDEX, error: e.message })
  }
}

function* changeUrl(action: AuroraAction) {
  switch (action.type) {
    case CHANGE_PERIOD:
      updateUrl({ t: action.period })
      break
    case CHANGE_MAGNETOMETER:
      updateUrl({ mag: action.magnetometer })
      break
  }
}

function* kIndexSaga() {
  yield takeLatest(REQUEST_PREDICTED_K_INDEX, fetchPredictedKIndex)
}

function* periodUrlSaga() {
  yield takeLatest([CHANGE_PERIOD, CHANGE_MAGNETOMETER], changeUrl)
}

export default function* root() {
  yield fork(kIndexSaga)
  yield fork(periodUrlSaga)
}
